<div class="header">
  <button (click)="close()" class="popup-close-button" tabindex="0"></button>
  <div *ngIf="!usesMaintainX && !usesFiix" class="title">{{ "ODetail.Work_Order_Required" | translate }}</div>
  <div *ngIf="usesMaintainX && !isEdit" class="title">{{ "ODetail.Send_Work_Request" | translate }}</div>
  <div *ngIf="isEdit" class="title">{{ "ODetail.Edit_Work_Request" | translate }}</div>
  <div *ngIf="usesFiix" class="title">{{ "ODetail.Send_Fiix_Work_Order" | translate }}</div>
</div>
<div *ngIf="!usesMaintainX && !usesFiix" class="body">
  <p>{{ "DASHBOARD.WORKORDER_POPUP_body" | translate }}</p>
  <input [(ngModel)]="workOrderNumber" id="worknumberInputFirst" type="text" value="">
</div>
<div *ngIf="usesMaintainX" class="body">
  <ion-spinner *ngIf="loadingWorkRequest" name="crescent"></ion-spinner>
  <ion-item>
    <ion-label>{{ 'SHARED.Work_Request_Priority' | translate }}</ion-label>
    <ion-select [(ngModel)]="priority" interface="alert">
      <ion-select-option value="NONE">{{ 'SHARED.None' | translate }}</ion-select-option>
      <ion-select-option value="LOW">{{ 'SHARED.Low' | translate }}</ion-select-option>
      <ion-select-option value="MEDIUM">{{ 'SHARED.Medium' | translate }}</ion-select-option>
      <ion-select-option value="HIGH">{{ 'SHARED.High' | translate }}</ion-select-option>
    </ion-select>
  </ion-item>
  <ng-container *ngIf="showAssetStatus">
    <ion-item>
      <ion-label>{{ 'SHARED.Asset_Status' | translate }}</ion-label>
      <ion-select [ngModel]="assetStatus" (ngModelChange)="onAssetStatusChange($event)" interface="alert">
        <ion-select-option value="">{{ 'SHARED.Work_Request_No_Change' | translate }}</ion-select-option>
        <ion-select-option value="ONLINE">{{ 'SHARED.Work_Request_Online' | translate }}</ion-select-option>
        <ion-select-option value="OFFLINE">{{ 'SHARED.Work_Request_Offline' | translate }}</ion-select-option>
        <ion-select-option value="IGNORE">{{ 'SHARED.Work_Request_Do_Not_Track' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item *ngIf="assetStatus === 'OFFLINE'">
      <ion-label>{{ 'SHARED.Work_Request_Downtime' | translate }}</ion-label>
      <ion-select [(ngModel)]="downtimeType" interface="alert">
        <ion-select-option value="UNPLANNED">{{ 'SHARED.Work_Request_Unplanned' | translate }}</ion-select-option>
        <ion-select-option value="PLANNED">{{ 'SHARED.Work_Request_Planned' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item *ngIf="customStatusOptions.length">
      <ion-label>{{ 'SHARED.Work_Request_Custom_Status' | translate }}</ion-label>
      <ion-select [(ngModel)]="customStatusID" interface="alert">
        <ion-select-option [value]="0">{{ 'SHARED.None' | translate }}</ion-select-option>
        <ion-select-option *ngFor="let s of customStatusOptions" [value]="s.customStatusID">{{ s.label }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ng-container>
  <ion-item>
    <ion-label position='stacked'>{{'SHARED.Work_Request_Title' | translate}}</ion-label>
    <ion-input [(ngModel)]="workRequestTitle" required="true" type="text"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">{{'SHARED.Work_Request_Description' | translate }}</ion-label>
    <ion-textarea #wrDescription [(ngModel)]="description" placeholder="{{'SHARED.Work_Request_Description' | translate}}"
                  rows="6"></ion-textarea>
  </ion-item>
</div>
<div *ngIf="usesFiix" class="body">
  <ion-item>
    <ion-label>{{ 'SHARED.Work_Request_Priority' | translate }}</ion-label>
    <ion-select [(ngModel)]="priority" interface="alert">
      <ion-select-option value="NONE">{{ 'SHARED.None' | translate }}</ion-select-option>
      <ion-select-option value="LOW">{{ 'SHARED.Low' | translate }}</ion-select-option>
      <ion-select-option value="MEDIUM">{{ 'SHARED.Medium' | translate }}</ion-select-option>
      <ion-select-option value="HIGH">{{ 'SHARED.High' | translate }}</ion-select-option>
    </ion-select>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">{{'SHARED.Work_Request_Title' | translate}}</ion-label>
    <ion-input [(ngModel)]="workRequestTitle" required="true" type="text"></ion-input>
  </ion-item>
  <ion-item>
    <ion-label position="stacked">{{'SHARED.Work_Request_Description' | translate}}</ion-label>
    <ion-textarea [(ngModel)]="description" rows="4"></ion-textarea>
  </ion-item>
</div>
<div class="button-block">
  <ion-button (click)="close()" class="page-button" color="light">{{ "SHARED.Cancel" | translate }}</ion-button>
  <ion-button (click)="createWorkOrder()" *ngIf="!usesMaintainX && !usesFiix" [disabled]="!workOrderNumber" class="page-button"
              color="secondary">{{ "SHARED.Save" | translate }}</ion-button>
  <ion-button (click)="createWorkOrder()" *ngIf="usesMaintainX" [disabled]="!workRequestTitle || loadingWorkRequest || loadFailed"
              class="page-button" color="secondary">{{ (isEdit ? "SHARED.Save" : "SHARED.Create") | translate }}
  </ion-button>
  <ion-button (click)="createWorkOrder()" *ngIf="usesFiix" [disabled]="!workRequestTitle" class="page-button"
              color="secondary">{{ "SHARED.Create" | translate }}</ion-button>
</div>
